/**
 * Base class for all custom application errors.
 * This allows for consistent error handling and identification of application-specific issues.
 */
export class AppError extends Error {
  /**
   * The HTTP status code appropriate for this error.
   */
  public readonly statusCode: number;

  /**
   * Optional details or context for the error, useful for logging.
   */
  public readonly details?: any;

  constructor(message: string, statusCode: number, details?: any, options?: ErrorOptions) {
    super(message, options);
    this.name = this.constructor.name;
    this.statusCode = statusCode;
    this.details = details;

    // This captures the stack trace correctly in V8.
    Error.captureStackTrace(this, this.constructor);
  }
}
